/**
 * Shared client for the App Engine email-server API.
 */

export const EMAIL_SERVER_URL =
  'https://email-server-dot-overhear-2.uc.r.appspot.com/api/send-email';

/**
 * Headers for email-server requests (includes API key when configured).
 *
 * Use Authorization Bearer only — the deployed email-server CORS allow-list
 * currently permits Authorization but not X-API-Key, which blocks browser
 * preflight from admin.theoverhear.app. The server already accepts Bearer.
 */
export function getEmailServerHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  const apiKey = import.meta.env.VITE_EMAIL_SERVER_API_KEY;
  if (typeof apiKey === 'string' && apiKey.trim() !== '') {
    headers.Authorization = `Bearer ${apiKey.trim()}`;
  }

  return headers;
}

export type EmailServerPayload = {
  to: string;
  subject: string;
  text?: string;
  html?: string;
  replyTo?: string;
  reply_to?: string;
  customData?: Record<string, unknown>;
};

/**
 * POST to the email-server API.
 */
export async function postToEmailServer(payload: EmailServerPayload): Promise<Response> {
  return fetch(EMAIL_SERVER_URL, {
    method: 'POST',
    headers: getEmailServerHeaders(),
    body: JSON.stringify(payload),
  });
}
